/* interceptor factory
** Author: Soc-dfsk -30
** Version: 1.0
** Date 10/01/2017 */

(function() {
	'use strict';

	App.factory('tokenInjector',['$q','$localStorage','$location','$rootScope','$injector', function($q,$localStorage,$location,$rootScope,$injector) {

			return {
				request: function(config) {
					//var token = $cookieStore.get('obj');
					if(config.url.indexOf('/api/') > 0){
						config.headers['versions']='1.0.0';
						if(config.url.indexOf("?")  < 0){
							config.url = config.url + (config.method == "GET" ? "?rand="+ Date.now() : "");
						}else {
							config.url = config.url + (config.method == "GET" ? "&rand="+ Date.now() : "");
						}
					}



					var token = $localStorage['token'];
					if(config.url.indexOf('amazonaws.com')>0 || config.url.indexOf('login') > 0 || config.url.indexOf('signup') > 0 || config.url.indexOf('verify') > 0 ||
						config.url.indexOf('createFolder') > 0 || config.url.indexOf('nurseProfile') > 0 || config.url.indexOf('fillable_template') > 0){
						return config;
					} else{
						if(token){
							config.headers['authorization'] = token;
						}
						return config;
					}
				},
				responseError: function(response) {
					//console.log(response);
					var $mdToast = $injector.get('toastr');
					var $state = $injector.get('$state');
					var $loading = $injector.get('$loading');
					var emailNotVerifiedMessage1 = "Your email has not been verified. A verification email has been sent again to your email account. Make sure to check your junk or spam folder";
					var emailNotVerifiedMessage2 = "Your account has not been activated. An activation email has been sent again to your email account. Make sure to check your junk or spam folder";
					if (response.statusCode == 401) {
						if (response.data) {
							console.log(response.data.message);
							if (response.data.message == emailNotVerifiedMessage1 || response.data.message == emailNotVerifiedMessage2) {
								$mdToast.error(response.data.message);
							}
						}
						$loading.finish('login');
						$state.go('login', { reload: true });
					} else if (response.status == 401) {
						if (response.data) {
							console.log(response.data.message);
							$mdToast.error(response.data.message);
							// if (response.data.message == emailNotVerifiedMessage1 || response.data.message == emailNotVerifiedMessage2) {
							// 	$mdToast.error(response.data.message);
							// }
						}
						$loading.finish('login');
						$state.go('login', { reload: true });
					} else if (response.data && response.data.statusCode == 401) {
						console.log(response.data.message);
						if (response.data.message == emailNotVerifiedMessage1 || response.data.message == emailNotVerifiedMessage2) {
								$mdToast.error(response.data.message);
							}
						$state.go('login', { reload: true });
					}
					else {
						return $q.reject(response);
					}
				}
			}

	}]);

})();